import React from "react";
import { ButtonSelectorProps } from "./types";
import classes from "./ButtonSelector.module.scss";

const ButtonSelector = ({ options, onSelect, selected, isLoading }: ButtonSelectorProps) => {
    return (
        <div className={classes.ButtonSelector}>
            {isLoading ? (
                <div className={"custom-loader"}></div>
            ) : (
                options.map((item, index) => (
                    <div
                        onClick={() => onSelect(item.label)}
                        key={index}
                        className={`${classes.Button} ${item.label === selected ? classes.Active : ""}`}
                    >
                        <span>{item.label}</span>
                    </div>
                ))
            )}
        </div>
    );
};
export default ButtonSelector;